// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_WorkOrderUpdateStatusInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/work_order_update_status/{work_order_id}
 *
 * Transition a work order to a new status.
 */
import { registerContract } from './validate'

export interface Orders_WorkOrderUpdateStatusInput {
status: string
}

registerContract('Orders_WorkOrderUpdateStatusInput', {
  status: { type: 'string',  required: true },
})
